module.exports = __webpack_public_path__ + "static/media/input_data_template_pick_ticket.3bd67cc4.csv";